import { waitForSeconds } from 'ts-utils';
import { Experiments } from '../helpers/experiments';
import { store } from '../store/Store';
import { Environment } from './Environment';

const DELAY_INITIALIZATION_SECONDS = 1;

export async function setupForIntegrationTests(): Promise<void> {
  if (Environment.E2E_TESTING) {
    // To allow Cypress to interact with the store we add it to the window
    window.store = store;
    // To allow Cypress to spy on Experiments
    window.Experiments = Experiments;

    // delay to allow spies to be attached before Experiment initialization has started
    await waitForSeconds(DELAY_INITIALIZATION_SECONDS);
  }
}
